<template>
  <div class="whs-list">
    <Status v-if="isLoading(wait.hotels) || error" :wait="wait.hotels" :error="error" />
    <div
      v-if="hotels.length > 0"
      class="whs-list-length"
    >Доступно отелей: {{ useFilter ? hotelsFiltered.length : hotels.length }}</div>
    <div
      v-if="!isLoading(wait.hotels) && hotels.length === 0"
      class="whs-list-length"
    >Доступных отелей нет</div>
    <transition name="fade">
      <div class="whs-list-result" v-if="rooms.length > 0">
        <div
          v-for="room in rooms"
          :key="room.hotel.id"
          class="whs-list-item"
          v-scroll="seenInWindow"
          :data-id="room.hotel.id"
        >
          <div class="whs-list-image-wrap">
            <div
              v-if="!room.hotel.info"
              class="whs-loading whs-icon-left"
            >Подождите, идет обновление информации об отелях</div>
            <transition name="fade">
              <img
                class="whs-list-image"
                v-if="room.hotel.info"
                :src="setThumbnail(room.hotel.info)"
                :alt="room.hotel.info.name"
                :key="setThumbnail(room.hotel.info)"
              />
            </transition>
            <template v-if="room.hotel.info && room.hotel.info.images.length > 0">
              <div class="whs-list-slide-left whs-icon" @click="lastSlide(room.hotel.info)"></div>
              <div
                class="whs-list-slide-length"
              >{{ currentSlide(room.hotel.info) + 1 }}/{{ room.hotel.info.images.length }}</div>
              <div class="whs-list-slide-right whs-icon" @click="nextSlide(room.hotel.info)"></div>
            </template>
          </div>
          <div class="whs-list-room">
            <div v-if="room.hotel.info" class="whs-list-hotel">
              <div class="whs-list-name">
                {{ room.hotel.info.name }}
                <div v-if="room.hotel.info.star_rating" class="whs-list-stars">
                  <div
                    v-for="star in (parseInt(room.hotel.info.star_rating / 10, 10))"
                    :key="star"
                    class="whs-list-star whs-icon"
                  ></div>
                </div>
              </div>
              <div class="whs-small whs-list-address">{{ room.hotel.info.clean_address }}</div>
              <div class="whs-small">{{ distanceFromCenter(room.hotel.info) }}</div>
              <!-- {{room.hotel.id}} -->
            </div>
            <div class="whs-list__title">{{ room.room_name}}</div>
            <div class="whs-list__price">{{ toLocalePrice(calcPrice(room)) }}</div>
            <div class="whs-small">{{nightsAdults}}</div>
            <div
              class="whs-list__meal whs-icon-left"
              :class="{'has-meal': room.meal !== 'nomeal'}"
            >{{ toLocaleMeal(room.meal) }}</div>
          </div>
          <div class="whs-list-next">
            <div
              class="whs-list-rating-wrap"
              v-if="room.hotel.info && room.hotel.info.rating && room.hotel.info.rating.total"
              :class="classNameFromRating(room.hotel.info.rating.total)"
            >
              <div class="whs-list-rating__total">{{ room.hotel.info.rating.total }}</div>
              <div class="whs-list-rating__verbose">{{ room.hotel.info.rating.total_verbose }}</div>
            </div>
            <Icons
              v-if="room.hotel.info && room.hotel.info.serp_filters"
              :info="room.hotel.info"
              style="padding: 8px 0"
            />
            <div
              v-if="room.hotel.info"
              class="whs-list__button--show"
              @click="proceedToHotel(room.hotel.id)"
            >Показать все номера</div>
          </div>
        </div>
      </div>
    </transition>
    <div class="whs-list-pagination" v-show="pageCount > 1">
      <div
        class="whs-list-pagination-item"
        v-for="(n, i) in pageCount"
        :key="n"
        @click="setPage(i)"
        :class="{'active': i === page}"
      >{{ n }}</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { distance, calcPrice } from '@/api';
// import Logo from '../assets/logo.png';
import Icons from '@/components/HotelListIcons.vue';
import Vue from 'vue';
import Status from '@/components/Status.vue';

Vue.directive('scroll', {
  inserted: function(el, binding) {
    let f = function(evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f);
      }
    };
    window.addEventListener('scroll', f);
  }
});

export default {
  name: 'HotelList',
  components: {
    Icons,
    Status
  },

  computed: {
    ...mapState(['loading']),
    ...mapState('hotels', [
      'useFilter',
      'hotelsFiltered',
      'hotels',
      'region',
      'wait',
      'error',
      'total_hotels',
      'total_pages',
      'next_page',
      'hotelsWaitingInfo',
      'page'
    ]),
    ...mapGetters(['isLoading']),
    ...mapGetters('hotels', ['rooms', 'pageCount']),
    ...mapGetters('hero', ['toLocalePrice']),
    ...mapState('hero', ['nightsAdults', 'currencyText'])
  },

  methods: {
    handleHotelMouseEnter(e) {
      e = e || window.event;
      setTimeout(
        this.$store.commit('hotels/updateHotelHoveredID', e.target.dataset.id),
        1000
      );
    },
    handleHotelMouseLeave() {
      setTimeout(
        this.$store.commit('hotels/updateHotelHoveredID'),
        1000
      );
    },
    seenInWindow(evt, el) {
      if (this.$route.path !== '/hotels') return false;
      if (this.hotelsWaitingInfo.includes(el.dataset.id)) return false;
      let elementTop = el.getBoundingClientRect().top;
      if (window.innerHeight > elementTop) {
        this.getHotelInfo(el.dataset.id);
      }
      return window.innerHeight > elementTop;
    },
    distanceFromCenter(info) {
      if (!info.latitude && !info.longitude) return '';

      let result = distance(
        info.latitude,
        info.longitude,
        this.region.latitude,
        this.region.longitude
      );
      if (result >= 1000) result = `${(result / 1000).toFixed(1)} км`;
      else result = `${result} м`;
      return `${result} от центра города`;
    },
    getHotelInfo(id) {
      if (this.hotelsWaitingInfo.includes(id)) return;
      this.$store.dispatch('hotels/getHotelInfo', id);
    },
    setThumbnail(info) {
      if (info._currentSlide) {
        return info.images[info._currentSlide].url;
      }
      if (
        !info.thumbnail ||
        info.thumbnail === 'https://partner.ostrovok.ru/static/img/1px.png'
      )
        return 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
      return info.thumbnail;
    },
    // toLocalePrice(price) {
    //   return `${Math.ceil(price, 10).toLocaleString('ru-Ru')} ${
    //     this.currencyText
    //   }`;
    // },
    toLocaleMeal(meal) {
      const i18n = {
        nomeal: 'Питание не включено',
        breakfast: 'Завтрак включен',
        'breakfast-buffet': 'Завтрак - Шведский стол',
        'continental-breakfast': 'Континентальный завтрак'
      };
      return i18n[meal] ? i18n[meal] : `Питание: ${meal}`;
    },
    classNameFromRating(rating) {
      const rate = parseInt(rating, 10);
      if (rate >= 9) return 'best';
      else if (rate >= 8) return 'better';
      else if (rate >= 7) return 'good';
    },
    currentSlide(info) {
      let slide = 0;
      if (typeof info._currentSlide === 'undefined') {
        this.$store.commit('hotels/setCurrentSlide', {
          id: info.id,
          slide,
          go: 'init'
        });
        slide = 0;
      } else {
        slide = info._currentSlide;
      }
      return slide;
    },
    lastSlide(info) {
      const slide = this.currentSlide(info);
      const lastSlide = slide === 0 ? info.images.length - 1 : slide - 1;
      this.$store.commit('hotels/setCurrentSlide', {
        id: info.id,
        slide: lastSlide,
        go: 'back'
      });
    },
    nextSlide(info) {
      const slide = this.currentSlide(info);
      const nextSlide = slide === info.images.length - 1 ? 0 : slide + 1;
      this.$store.commit('hotels/setCurrentSlide', {
        id: info.id,
        slide: nextSlide,
        go: 'next'
      });
    },
    proceedToHotel(id) {
      this.$router.push({ path: `/hotels/${id}`, query: this.$route.query });
    },
    setPage(n) {
      this.$parent.$refs.hero.$el.scrollIntoView();
      this.$store.commit('hotels/setPage', n);
    },
    calcPrice
  }
};
</script>

<style scoped>
.whs-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--color-bg);
}
.whs-list-status {
  padding: 24px;
  width: 100%;
  position: relative;
  background-color: var(--color-bg);
}
.whs-progress {
  position: absolute;
  top: 0;
  left: 0;
  height: 4px;
  background-color: var(--color-main);
}
.whs-error,
.whs-loading,
.whs-list-status {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.whs-error:before,
.whs-loading:before {
  content: '\f1ce';
  font-size: 24px;
  width: 24px;
  height: 24px;
  color: var(--color-main);
  animation: spin 2s infinite;
}
.whs-error:before {
  content: '\f071';
  animation: none;
}
@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
/* .whs-error {
} */
.whs-list-length {
  margin-bottom: 12px;
  padding: 4px 8px;
  align-self: flex-start;
  border-radius: 36px;
  background-color: var(--color-bg-dark);
}
/* .whs-list-content {
} */
.whs-list-result {
  background-color: var(--color-bg);
  /* padding: 12px; */
  /* max-width: 800px; */
}
.whs-list-item {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin-bottom: 12px;
  background-color: #fff;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: 0 0 1px var(--color-text-5), 0 0 8px var(--color-bg-dark);
}
.whs-list-room {
  padding: 8px 16px;
  flex: 3 0 300px;
}
.whs-list-image-wrap {
  height: 220px;
  flex: 2 0 200px;
  overflow: hidden;
  /* background-color: var(--color-third); */
  background-color: var(--color-bg-dark);
  position: relative;
}
.whs-list-image-wrap .whs-loading {
  padding: 24px;
}
.whs-list-image {
  width: 100%;
  height: 220px;
  object-fit: cover;
}
.whs-list-hotel {
  padding-bottom: 8px;
  margin-bottom: 4px;
  border-bottom: 1px solid var(--color-bg-dark);
}
.whs-list-stars {
  display: inline-flex;
}
.whs-list-star:before {
  content: '\f005';
  color: var(--color-third);
  font-size: 8px;
  margin-right: 2px;
}
.whs-list-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-main);
  cursor: pointer;
}
.whs-list-address {
  color: var(--color-main);
}
.whs-list__title {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-5);
  max-height: 38px;
  overflow: hidden;
}
.whs-list__price {
  padding-top: 4px;
  font-size: 22px;
  font-weight: 700;
}
.whs-list__meal {
  margin-top: 8px;
  padding: 2px 4px;
  background-color: var(--color-bg);
  border-radius: 2px;
  display: inline-flex;
}
.whs-list__meal.has-meal {
  background-color: var(--color-third);
  color: #fff;
}
.whs-list__meal:before {
  content: '\f725';
  margin-right: 8px;
  align-self: center;
  text-align: center;
  color: #fff;
}
.whs-list__meal:not(.has-meal):before {
  color: var(--color-text-5);
  content: '\f2e7';
}

.whs-list-next {
  padding: 8px 18px;
  flex: 1 0 130px;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
}
.whs-list__button--show {
  width: 100%;
  text-align: center;
  /* background: linear-gradient(var(--color-alt) -50%, var(--color-main)); */
  background: var(--color-button);
  outline: none;
  padding: 7px 14px;
  border-bottom: 2px solid var(--color-alt);
  font-family: 'Open Sans';
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  border-radius: 4px;
}
.whs-list__button--show:hover {
  background: var(--color-button-hover);
  /* background: linear-gradient(
    to top,
    var(--color-second) -20%,
    var(--color-second-alt) 150%
  ); */
  border-bottom: 2px solid var(--color-second-alt);
}

.whs-list-rating-wrap {
  display: flex;
  align-items: center;
}
.whs-list-rating__total {
  width: 28px;
  padding: 3px;
  margin-right: 4px;
  background-color: var(--color-bg);
  font-weight: 600;
  font-size: 16px;
  border-radius: 100%;
  text-align: center;
}
.best .whs-list-rating__total {
  background-color: var(--color-third);
  color: #fff;
}
.better .whs-list-rating__total {
  background-color: var(--color-bg-warm);
  color: #fff;
}
.good .whs-list-rating__total {
  background-color: var(--color-alt);
  color: #fff;
}
.whs-list-rating__verbose {
  font-size: 12px;
}
.whs-list-slide-left,
.whs-list-slide-right {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 32px;
  height: 32px;
  cursor: pointer;
  text-align: center;
  opacity: 0.7;
}
.whs-list-slide-left {
  right: 64px;
}
.whs-list-slide-left:before,
.whs-list-slide-right:before {
  content: '\f0da';
  font-size: 32px;
  color: #fff;
}
.whs-list-slide-left:before {
  content: '\f0d9';
}
.whs-list-slide-left:hover,
.whs-list-slide-right:hover {
  opacity: 1;
}
.whs-list-slide-length {
  position: absolute;
  right: 32px;
  bottom: 0;
  text-align: center;
  width: 32px;
  height: 32px;
  line-height: 32px;
  font-weight: 600;
  color: #fff;
}
.whs-list-pagination {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 24px;
  max-width: 800px;
  padding: 12px;
  align-items: center;
  justify-content: center;
}
.whs-list-pagination-item {
  margin: 1px;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-alt-5);
  color: var(--color-main);
  font-size: 18px;
  font-weight: 600;
}
.whs-list-pagination-item.active,
.whs-list-pagination-item.active:hover {
  cursor: default;
  color: var(--color-text);
  background-color: transparent;
}
.whs-list-pagination-item:hover {
  background-color: var(--color-third);
  color: var(--color-second-alt);
}
</style>